import { MediaItemImageDisplay } from '../Shared/FrameModules/MediaLibrary/item_image.js';

FrameModules.add('WikiImageFrameModule', function() {
   when($('pageImages'), function(imageThumbs) {
      WikiImageManager.initialize();

      when($('wikiSummaryImage'), function(elementId) {
         var targetElement = $(elementId);
         if (!targetElement) {
            return;
         }

         var target = MediaTarget.createFromElement(targetElement);
         target.addEvent('itemChanged', function(mediaItem, old) {
            if (!mediaItem) {
               return;
            }
            WikiImageManager.addImage(mediaItem, old);
         });
      });
   });
});

export var WikiImageManager = (window.WikiImageManager = {
   initialize: function() {
      var self = this;
      this.thumbsContainer = $('pageImages');
      this.imageMeta = $$('.imageMeta');

      // Get image data for each of the images attached to this wiki, and then
      var wikiid;
      if ((wikiid = $('wikiid').get('text'))) {
         new Request.AjaxIO('getWikiImages', {
            onSuccess: function(images) {
               images.map(function(itemData) {
                  var mediaItem = MediaItem.createFromData(itemData);
                  self.addImage(mediaItem);
               });
            },
         }).send(wikiid);
      }
   },

   addImage: function(mediaItem, toReplace) {
      if (toReplace) {
         this.removeImage(toReplace);
      }

      var thumb = new MediaItemImageDisplay(mediaItem, {
         size: 'thumbnail',
         useBackground: false,
         showFilename: false,
         menu: false,
      });
      var thumbElement = thumb.getElement();
      this.thumbsContainer.grab(thumbElement);

      var hideEvent,
         text = this.imageMeta.getFirst();

      // Show the imageid for 5 seconds on hover
      thumbElement.addEvent('mouseenter', function(ev) {
         clearTimeout(hideEvent);
         text.set('text', mediaItem.getGlobalID());
         hideEvent = text.makeInvisible.delay(5000, text);
      });

      this.imageMeta.addEvents({
         mouseenter: function(ev) {
            clearTimeout(hideEvent);
            text.makeVisible();
         },
         mouseleave: function(ev) {
            hideEvent = text.makeInvisible.delay(5000, text);
         },
      });
   },

   removeImage: function(mediaItem) {
      return $$('#pageImages .mediaItem[data-imageid="' + mediaItem.getID() + '"]').dispose();
   },
});
